import { Col, Form, Row } from 'antd'
import React, { useState } from 'react'
import CommonFields from '../ReturnExchange/CommonFields'
import InnerCardHeader from '../../../../components/atoms/cardHeader/InnerCardHeader'
import BottomComboButtons from '../../../../components/atoms/formFields/buttons/bottomComboButtons'
import { SaveCancellationPolicy, UpdateCancellationPolicy } from '../../../../store/thunks/vendorStoreThunk'
import { useDispatch, useSelector } from 'react-redux'
import { isNumberOnly } from '../../../../utils/regex'

const Cancellation = ({ storeId }) => {
    const dispatch = useDispatch();
    const { data: cancellation } = useSelector((state) => state?.cancellationPolicy);
    const [returnData, setReturnData] = useState();
    const [errors, setErrors] = useState();
    return (
        <Form>
            <InnerCardHeader name="Cancellation" />
            <div className="p-4">
                <Row gutter={[12, 5]} id="ant_inputs">
                    <CommonFields type="Cancellation" returnData={returnData} setReturnData={setReturnData} errors={errors} setErrors={setErrors} storeId={storeId} />
                </Row>
                <BottomComboButtons name1={"Cancel"} name2={"Save"} extraClasses="w-100" onClick2={(e) => {
                    e.preventDefault();
                    if (
                        returnData?.cancellationEligibleDays &&
                        returnData?.cancellationEligiblePolicy
                    ) {
                        cancellation?.id ? dispatch(UpdateCancellationPolicy({ payload: returnData })) : dispatch(SaveCancellationPolicy({ payload: returnData }))
                        setErrors({});
                    } else {
                        setErrors({
                            ...errors,
                            cancellationEligibleDays: returnData?.cancellationEligibleDays
                                ? (isNumberOnly(returnData?.cancellationEligibleDays) ? "" : "Invalid Days")
                                : "Number of Days is Mandatory",
                            cancellationEligiblePolicy: returnData?.cancellationEligiblePolicy
                                ? ""
                                : "Cancellation Policy is Mandatory",
                        });
                        returnData.cancellationEligiblePolicy
                            ? document
                                .querySelector(" .CancellationRules .tox-tinymce")
                                .classList.remove("invalid")
                            : document
                                .querySelector(".CancellationRules .tox-tinymce")
                                .classList.add("invalid");
                    }
                }} />
            </div>
        </Form>
    )
}

export default Cancellation